// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MMS9k","col":"styles_col__9hCFw"};